<script lang="ts">
	import '$lib/style/main.css';
	import { onMount } from 'svelte';
	// import { svelteinitiate } from '$lib/config/svelte';
	// onMount(() => {
	// 	svelteinitiate();
	// });
	
	import { page } from '$app/stores';

	// Reactive canonical URL
	$: canonicalUrl = $page.url.origin + $page.url.pathname;
	
	onMount(() => {
		console.log('Menunggu 10 detik untuk merender <noscript>...');

		setTimeout(() => {
			const gtmNoscript1 = document.createElement('noscript');
			gtmNoscript1.innerHTML = `
          <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PWFPC5P" height="0" width="0" style="display:none;visibility:hidden"></iframe>
      `;
			document.body.appendChild(gtmNoscript1);

			const gtmNoscript2 = document.createElement('noscript');
			gtmNoscript2.innerHTML = `
          <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PRNH9S9" height="0" width="0" style="display:none;visibility:hidden"></iframe>
      `;
			document.body.appendChild(gtmNoscript2);

			console.log('<noscript> telah dirender setelah 10 detik.');
		}, 10000);
	});
</script>

<svelte:head>
	<link rel="canonical" href="{canonicalUrl}" />
	<meta property="og:url" content="{canonicalUrl}" />
	<meta property="og:type" content="website">
</svelte:head>

<div>
	<main>
		<slot />
	</main>
</div>
